import React from "react";

import { SurveyResultsTable } from "../../sections";

type SummaryProps = {
	surveyId: string;
	enableSuperRows?: boolean;
};

const Summary = ({ surveyId, enableSuperRows = false }: SummaryProps) => {
	return (
		<div className="mt-4">
			<SurveyResultsTable surveyId={surveyId} enableSuperRows={enableSuperRows} />
		</div>
	);
};

export default Summary;
